import { render } from "./WechatAccount.vue?vue&type=template&id=0a6e0f97&scoped=true"
import script from "./WechatAccount.vue?vue&type=script&lang=js"
export * from "./WechatAccount.vue?vue&type=script&lang=js"

import "./WechatAccount.vue?vue&type=style&index=0&id=0a6e0f97&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6e0f97"]])

export default __exports__